module.exports = __webpack_public_path__ + "static/img/11b.947ad7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/11b.jpg
// module id = tcMh
// module chunks = 0